import { configure } from "mobx";

configure({ enforceActions: "observed" });



// WEBPACK FOOTER //
// ./app/config/general.ts